<template>
  <div class="gx-pw">
    <top-banner
      :nav-items="navItems"
      :unread="unreadCount"
      @logo="goHome"
      @nav="onNav"
      @bell="goNotification"
      @legacy="goLegacy"
      @logout="logout"
    />

    <div class="gx-layout">
      <!-- 侧栏 -->
      <aside class="gx-pw__sidebar" :style="{ width: collapsed ? '48px' : '210px' }">
        <button class="gx-pw__collapse" @click="collapsed = !collapsed">
          <span :style="{ transform: collapsed ? 'rotate(180deg)' : 'none' }">◀</span>
        </button>

        <nav class="gx-nav">
          <template v-for="item in newUiVisibleItems('presales', menu)">
            <div v-if="item.children" :key="item.id" class="gx-nav__group">
              <button class="gx-nav__item gx-nav__item-parent" :class="{ 'gx-nav__item--on':activeParentId === item.id }" :title="collapsed ? item.label : undefined" @click="toggleGroup(item.id)">
                <span class="gx-nav__item-icon">{{ item.icon }}</span>
                <span v-if="!collapsed" class="gx-nav__group-label">{{ item.label }}</span>
                <span>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" :style="`flex-shrink: 0; transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1); transform: rotate(${openGroups[item.id]?180:0}deg); opacity: 0.7;`"><path d="M2 3.5l3 3 3-3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </button>
              <div v-if="openGroups[item.id] && !collapsed" class="gx-nav__group-children">
                <button
                    v-for="child in item.children"
                    :key="child.id"
                    class="gx-nav__item gx-nav__item-child"
                    :class="{ 'gx-nav__item--on': activeId === child.id }"
                    :title="collapsed ? child.label : undefined"
                    @click="go(child,item.id)"
                >
                  <span class="gx-nav__item-icon">{{ child.icon }}</span>
                  <span v-if="!collapsed" class="gx-nav__item-label">{{ child.label }}</span>
                </button>
              </div>
            </div>
            <!-- 单独共享菜单 -->
            <button
                v-else
                :key="item.id"
                class="gx-nav__item"
                :class="{ 'gx-nav__item--on': activeId === item.id }"
                :title="collapsed ? item.label : undefined"
                @click="go(item)"
            >
              <span class="gx-nav__item-icon">{{ item.icon }}</span>
              <span v-if="!collapsed" class="gx-nav__item-label">{{ item.label }}</span>
            </button>
          </template>
        </nav>

      </aside>

      <!-- 内容区 -->
      <main class="gx-main">
        <!-- 订单管理 -->
        <new-order-list-page :initial-shop-type="activeShopType" v-if="activeId === 'dou-order-mag'||activeId === 'wx-order-mag'" />
      </main>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TopBanner from '../../components/newUi/TopBanner.vue'
import NewOrderListPage from '../orderList/index.vue'
import newUiPermissionMixin from '../../mixins/newUiPermission'

export default {
  name: 'NewPresalesWorkbenchPage',
  mixins: [newUiPermissionMixin],
  components: { TopBanner, NewOrderListPage },
  data() {
    return {
      navItems: [
        { id: null, label: '星人工作台' },
        { id: 'agent', label: 'Agent工作台' },
        { id: 'shop', label: '店铺工作台' },
        { id: 'finance', label: '财务工作台' },
        { id: 'ops', label: '运营工作台' },
        { id: 'select', label: '选品工作台' },
        { id: 'cloud', label: '云库工作台' },
        { id: 'goods', label: '商品工作台' },
        { id: 'presales', label: '售前工作台', active: true },
        { id: 'aftersales', label: '售后工作台' },
        { id: 'system', label: '系统工作台' }
      ],
      menu: [
        { id: 'dou-order', label: '抖店订单', icon: '🎵', legacy: '/uc_order',
        children:[ { id: 'dou-order-mag', label: '订单管理', icon: '🧾', legacy: '/uc_order',shopType:1}]},
        { id: 'wx-order', label: '微店订单', icon: '💬', legacy: '/uc_order',
        children:[ { id: 'wx-order-mag', label: '订单管理', icon: '🧾', legacy: '/uc_order',shopType:7}]},
      ],
      collapsed: false,
      activeId: 'dou-order-mg',
      activeShopType:1,
      openGroups: { 'dou-order': true, 'wx-order': true },
      activeParentId:'',//当前父级菜单
    }
  },
  computed: {
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    }
  },
  created() {
    const t = this.$route.query.menu
    if (t && this.findItem(t)) this.activeId = t
    this.$store.dispatch('notification/initNotificationWS')
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    findItem(id) {
      for (const item of this.menu) {
        if (item.id === id) return item
        if (item.children) {
          const found = item.children.find((c) => c.id === id)
          if (found){
            this.activeParentId = item.id||''
            this.activeShopType = found.shopType
            return found
          }
        }
      }
      return null
    },
    toggleGroup(id) {
      this.$set(this.openGroups, id, !this.openGroups[id])
    },
    go(item) {
      this.activeId = item.id
      this.activeShopType  = item.shopType
      if (this.$route.path !== '/new_presales_workbench' || this.$route.query.menu !== item.id) {
        this.$router.replace({ path: '/new_presales_workbench', query: { menu: item.id } }).catch(() => {})
      }
    },
    goLegacy() {
      this.$router.push('/ucenter_legacy')
    },
    onNav(id) {
      if (id === null) {
        this.$router.push('/ucenter')
        return
      }
      const map = {
        agent: '/new_uc_shop_manage',
        shop: '/new_uc_shop_manage',
        finance: '/new_finance_workbench',
        ops: '/new_ops_workbench',
        select: '/new_select_workbench',
        cloud: '/new_cloud_workbench',
        goods: '/new_goods_workbench',
        presales: '/new_presales_workbench',
        aftersales: '/new_aftersales_workbench',
        system: '/new_system_workbench'
      }
      const route = map[id]
      if (!route) {
        this.$message({ message: '该工作台功能开发中，敬请期待', type: 'warning' })
        return
      }
      this.$router.push(route)
    },
    goHome() {
      this.$router.push('/')
    },
    goNotification() {
      this.$router.push('/notification')
    },
    logout() {
      this.OUT_LOGIN()
      this.$message({ message: '已退出登录', type: 'success' })
      location.href = '/'
    }
  }
}
</script>

<style scoped>
.gx-pw {
  min-height: 100vh;
  background: #F4F6F8;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-pw__sidebar {
  flex-shrink: 0;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
  transition: width .25s cubic-bezier(.4, 0, .2, 1);
}
.gx-pw__sidebar::-webkit-scrollbar {
  display: none;
}
.gx-pw__collapse {
  position: absolute;
  top: 10px;
  right: -12px;
  z-index: 20;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(212, 169, 70, .3);
  background: #EEF1F6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
}
.gx-pw__collapse:hover {
  background: #1a2040;
  border-color: #D4A946;
}
.gx-pw__collapse span {
  font-size: 10px;
  color: #A0AEC0;
  display: inline-block;
  transition: transform .25s;
}

.gx-nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: none;
}
.gx-nav__group {
  margin-bottom: 4px;
}

.gx-nav__group-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: auto;
}
.gx-nav__group-children {
  padding: 2px 0;
}
.gx-nav__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 9px 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  transition: all .18s ease;
}
.gx-nav__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}
.gx-nav__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 600;
}
.gx-nav__item-icon {
  font-size: 15px;
  flex-shrink: 0;
}
.gx-nav__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-nav__item-parent.gx-nav__item--on{
  background: rgba(255, 255, 255, 0.6);
}
.gx-nav__item-child {
  gap: 8px;
  padding: 6px 14px 6px 26px;
}
.gx-nav__item-child  .gx-nav__item-icon{
  font-size: 13px;
  opacity: 0.65;
}

.gx-nav__item-child .gx-nav__item-label {
  font-size: 12px;
}
.gx-nav__item--on .gx-nav__item-icon{
  opacity: 1;
}

</style>
